import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "./components/landing/Navbar";
import { Hero } from "./components/landing/Hero";
import { Marquee } from "./components/landing/Marquee";
import { Collection } from "./components/landing/Collection";
import { Heritage } from "./components/landing/Heritage";
import { Story } from "./components/landing/Story";
import { Waitlist } from "./components/landing/Waitlist";
import { Footer } from "./components/landing/Footer";
import AdminLogin from "./pages/AdminLogin";
import AdminWaitlist from "./pages/AdminWaitlist";

const Home = () => {
  return (
    <main data-testid="home-page" className="bg-[#0a0705]">
      <Navbar />
      <Hero />
      <Marquee />
      <Collection />
      <Heritage />
      <Story />
      <Waitlist />
      <Footer />
    </main>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/waitlist" element={<AdminWaitlist />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#140E0B",
            border: "1px solid rgba(230, 204, 152, 0.25)",
            color: "#FDFBF7",
            fontFamily: "Outfit, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
